<template>
    <section class="exchanges">
        <landing-container>
            <h3
                class="exchanges__title"
            >{{ $t('PLCU on Exchanges') }}</h3>
            <div class="exchanges__dividerWrapper">
                <divider />
            </div>
            <div
                class="exchanges__logos"
            >
                <div
                    v-for="(exchange, index) in exchanges"
                    :key="index"
                    class="exchangeLogo"
                >
                    <a :href="exchange.url" target="_blank">
                        <img
                            :src="require(`img/landing/exchanges/${exchange.logo}`)"
                            :alt="exchange.name"
                            class="exchangeLogo__img"
                        />
                    </a>
                </div>
            </div>
        </landing-container>
    </section>
</template>

<script>
import { localExchanges } from '@/config'
import LandingContainer from "@/components/Landing/components/LandingContainer.vue";
import Divider from "@/components/Landing/components/Divider";

export default {
    name: 'LandingExchanges',
    components: {Divider, LandingContainer},
    data() {
        return {
            exchanges: localExchanges,
        }
    },
}
</script>

<style lang="scss" scoped>
.exchanges {
    padding: 48px 0;

    @media (min-width: $breakpoint-md) {
        padding: 64px 0;
    }

    @media (min-width: $breakpoint-xl) {
        padding: 96px 0;
    }

    &__title {
        color: #1c1c1e;
        font-family: $font-secondary;
        font-size: 24px;
        font-weight: 700;
        line-height: 32px;
        text-align: center;

        @media (min-width: $breakpoint-xl) {
            font-size: 28px;
            line-height: 36px;
        }
    }

    &__dividerWrapper {
        display: flex;
        justify-content: center;
        margin-top: 16px;
        margin-bottom: 48px;

        @media (min-width: $breakpoint-md) {
            margin-bottom: 64px;
        }

        @media (min-width: $breakpoint-xl) {
            margin-bottom: 96px;
        }
    }

    &__logos {
        align-items: center;
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        justify-content: center;

        @media (min-width: $breakpoint-md) {
            gap: 24px 32px;
        }
    }
}

.exchangeLogo {
    display: flex;
    flex: 1 calc(50% - 24px);
    height: 48px;
    justify-content: center;
    width: 136px;

    @media (min-width: 768px) {
        flex: 0 auto;
        width: 152px;
        height: 56px;
    }

    @media (min-width: 1200px) {
        flex: 0 auto;
        width: 208px;
        height: 56px;
    }

    &__img {
        height: 100%;
        transition: transform 0.3s;

        &:hover {
            @media (hover: hover) and (pointer: fine) {
                transform: scale(1.2);
            }
        }
    }
}
</style>